import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

export class PaginatedLinks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nbPages: Math.ceil(props.totalRows / props.perPage),
        };
    }

    /**
     * Get page range.
     *
     * @param {Number} start
     * @param {Number} end
     *
     * @return {Array}
     */
    getPageRange(start, end) {
        let rangeCounter = 0;

        return Array(this.state.nbPages)
            .fill()
            .map(() => {
                rangeCounter += 1;

                return rangeCounter;
            })
            .filter(page => (page >= start && page <= end));
    }

    /**
     * Checks if current page is first page.
     *
     * @return {Boolean}
     */
    isOnFirstPage() {
        return this.props.currentPage === 1;
    }

    /**
     * Check if the given page is the current page.
     *
     * @param {Number} pageNumber
     *
     * @return {Boolean}
     */
    isCurrentPage(pageNumber) {
        return this.props.currentPage === pageNumber;
    }

    /**
     * Check if the current page is the last page.
     *
     * @return {Boolean}
     */
    isOnLastPage() {
        return this.props.currentPage === this.state.nbPages;
    }

    /**
     * Create page range buttons to render between previous and next.
     *
     * @return {JSX}
     */
    createPageRange() {
        const range = Math.floor(this.props.pageRange / 2);

        let beforeCurrent = this.props.currentPage - range;
        let afterCurrent = this.props.currentPage + range;

        if (beforeCurrent < 1) {
            afterCurrent = this.props.pageRange;
        }

        if (afterCurrent > this.state.nbPages) {
            beforeCurrent -= afterCurrent - this.state.nbPages;
        }

        return this.getPageRange(beforeCurrent, afterCurrent).map(page => (
            <li key={ page } className={ `page-item ${this.isCurrentPage(page) ? 'disabled active' : ''}` }>
                { (
                    this.isCurrentPage(page) ?
                        <span className={ `page-link pageBtn page-number-${page}` }>{ page }</span> :
                        <a
                            className={ `page-link pageBtn page-number-${page}` }
                            onClick={ () => this.props.setPageHandler(page) }
                        >
                            { page }
                        </a>
                ) }
            </li>
        ));
    }

    /**
     * Create previous page button.
     *
     * @return {JSX}
     */
    createPreviousPage() {
        return (
            <li className={ `page-item ${this.isOnFirstPage() ? 'disabled' : ''}` }>
                {
                    (this.isOnFirstPage() ?
                        <span className="page-link previousPageBtn">&laquo;</span> :
                        <a
                            className="page-link previousPageBtn"
                            onClick={
                                () => this.props.setPageHandler(this.props.currentPage - 1)
                            }
                            rel="prev"
                        >
                            &laquo;
                        </a>
                    )
                }
            </li>
        );
    }

    /**
     * Create next page button.
     *
     * @return {JSX}
     */
    createNextPage() {
        return (
            <li className={ `page-item ${this.isOnLastPage() ? 'disabled' : ''}` }>
                {
                    (this.isOnLastPage() ?
                        <span className="page-link nextPageBtn">&raquo;</span> :
                        <a
                            className="page-link nextPageBtn"
                            onClick={ () => this.props.setPageHandler(this.props.currentPage + 1) }
                            rel="next"
                        >
                            &raquo;
                        </a>
                    )
                }
            </li>
        );
    }

    /**
     * Renders the component.
     *
     * @return {JSX}
     */
    render() {
        return (
            <Fragment>
                { this.state.nbPages > 1 &&
                <ul className="pagination m-t-none">
                    { this.createPreviousPage() }
                    { this.createPageRange() }
                    { this.createNextPage() }
                </ul> }
            </Fragment>
        );
    }
}

PaginatedLinks.propTypes = {
    totalRows: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    pageRange: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    setPageHandler: PropTypes.func.isRequired,
};

PaginatedLinks.defaultProps = {};

export default PaginatedLinks;
